
import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { VehicleType } from "../../vehicles-types/_types/vehicle-type";
import { Worker } from "../../workers/_types/worker";
import { Company } from "../../companies/_types/company";
import { Business } from "../../business/_types/business";

export class vehicleOwner extends Resource {
    public override type = 'vehicleOwners';

    @prop()
    @required()
    public name!: string;      

}